import axios from 'axios';

axios.setToken = (authToken) => {
    axios.defaults.headers.common['Authorization'] = `bearer ${authToken}`;
    axios.defaults.headers.get['Authorization'] = `bearer ${authToken}`;
};

export default axios;